<template>
    <div class="memberDatumBox">
        <!--<div class="memberRuleNav">-->
            <!--<i class="iconfont iconzuojiantou" @click="returnFn"></i>-->
        <!--</div>-->
        <div class="memberContent">
            <div class="memberImgBox">
                <div class="imgbox">
                    <img :src="userData.wxHeadImgUrl">
                </div>
                <div class="memberName">{{userData.wxNickName}}</div>
            </div>
            <div class="memberMain">
                <div class="mainRow"><span class="memberTitle">帐号：</span><span>{{userData.cardAccount}}</span></div>
                <div class="mainRow"><span class="memberTitle">卡号：</span><span>{{userData.cardCodeNo}}</span></div>
                <div class="mainRow"><span class="memberTitle">姓名：</span><span>{{userData.name}}</span></div>
                <div class="mainRow"><span class="memberTitle">电话：</span><span>{{userData.phone}}</span></div>
                <div class="mainRow"><span class="memberTitle">卡类别：</span><span>{{userData.vipclsname}}</span></div>
            </div>
            <div class="mbtn" @click="gotoRouter">修改会员资料</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "memberDatum",
        data(){
          return {
              userData:''
          }
        },
        mounted() {
            this.userData = JSON.parse(localStorage.getItem("userData"))
            document.title = "会员资料"
        },
        methods:{
            gotoRouter(){
                this.$router.push('/modificationVip')
            }
        }
    }
</script>

<style lang="scss" scoped>
.memberDatumBox{
    width: 100%;
    height: 100%;
    background-color: #fff;
    .memberContent{
        position: absolute;
        /*top: 45px;*/
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .mbtn{
        width: 80%;
        height: 40px;
        background-color:#2db7f5 ;
        text-align: center;
        color: #fff;
        line-height: 40px;
        border-radius: 6px;
        position: absolute;
        bottom: 30px;
    }
    .memberImgBox{
        width: 100%;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #f5f5f5;
    }
    .imgbox{
        border-radius: 50%;
        width: 70px;
        height: 70px;
        overflow: hidden;
        border: 1px solid #f1f1f1;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .memberName{
        font-size: 14px;
        margin-top: 5px;
        color: #555;
    }
    .memberMain{
        width: 70%;
        margin-top: 20px;
    }
    .mainRow{
        font-size: 16px;
        color: #555;
        display: flex;
        height: 30px;
        line-height: 30px;
        span{
            text-align: right;
        }
    }
    .memberTitle{
        width: 80px;
    }
}
</style>
